import { getAdvertisment, getAllAdvertismentGallery, getCategory, editStateAdvertismentData, deleteAdvertisment } from "../../../api/advertisment/review/index.js";
import { Button, Paper, Skeleton } from "@mui/material";
import { Box } from "@mui/system";
import { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate, useParams } from "react-router-dom";
import { toast } from "react-toastify";
import { PageTitle } from "../../../../../shared/ui/common/index.js";

import { Confirm } from "../../../../../shared/ui/modals/index.js";



import { logout } from "../../../../../shared/state/slices/user.js";
import Breadcrumb from "./ads/breadcrumb.jsx";
import Gallery from "./ads/gallery/index.jsx";
import AdInfo from "./ads/info.jsx";
import Location from "./ads/location.jsx";
import Summery from "./ads/summery.jsx";

const ReviewAds = () => {
  const [data, setData] = useState({ files: [], selectedProductImage: [] });

  const [loading, setLoading] = useState(false);

  const [openDelete, setOpenDelete] = useState(false);
  const [openDelete2, setOpenDelete2] = useState(false);
  const [openDelete3, setOpenDelete3] = useState(false);

  const [galleries, setGalleries] = useState([]);
  const { id } = useParams();
  const [category, setcategory] = useState({});

  const dispatch = useDispatch();

  const { token } = useSelector((state) => state.user);
  useEffect(() => {
    setLoading(true);
    getAdvertisment(id, token)
      .then((res) => {
        const { data } = res;
        setData(data?.data);
        setLoading(false);
      })
      .catch((err) => {
        if (err.response.status === 401) {
          dispatch(logout());
        }
        setLoading(false);
      });
    getAllAdvertismentGallery(id, token)
      .then((res) => {
        const { data } = res;
        setGalleries(data?.data[0] || []);
        setLoading(false);
      })
      .catch((err) => {
        if (err.response.status === 401) {
          dispatch(logout());
        }
        setLoading(false);
      });
  }, []);
  useEffect(() => {
    if (data?.advertisement?.galleryId) {
      getCategory(data, token)
        .then((res) => {
          const { data } = res;
          setcategory(data?.data);
        })
        .catch((err) => {
          if (err.response.status === 401) {
            dispatch(logout());
          }
        });
    }
  }, [data?.advertisement]);
  const checkReview = (state) => {
    const data = { state, id: Number(id) };
    editStateAdvertismentData(data, token)
      .then((res) => {
        const { data } = res;
        /*   setData({ ...data, state: state }); */
        setOpenDelete(false);
        setOpenDelete2(false);
        setOpenDelete3(false);
        toast.success(`آگهی با موفقیت ${state === 1 ? "تایید " : "رد"} شد`);
      })
      .catch((err) => {
        if (err.response.status === 401) {
          dispatch(logout());
        }
      });
  };
  const navigate = useNavigate();
  const setDelete = () => {
    deleteAdvertisment(id, token)
      .then((res) => {
        navigate("/advertisment");
      })
      .catch((err) => {
        if (err.response.status === 401) {
          dispatch(logout());
        }
      });
  };
  return (
    <>
      <PageTitle
        title="  آگهی "
        broadCrumb={[
          {
            title: "اگهی ها",
            path: "/advertisment",
          },
        ]}
      />
      <div className="px-3 biggerButton">
        <Box sx={{ direction: "ltr !important" }} className="pb-20 ">
          {loading ? (
            <>
              <Skeleton animation="wave" width={"100%"} height={50} />
              <Box
                sx={{ direction: "ltr !important" }}
                className="md:grid grid-cols-2 gap-7"
              >
                <Skeleton
                  animation="pulse"
                  variant="rounded"
                  /* sx={{mt:"-130px "}} */ width={"100%"}
                  height={700}
                />{" "}
                <div>
                  <Skeleton animation="wave" width={"100%"} height={100} />
                  <Skeleton variant="rounded" width={"100%"} height={500} />
                </div>
              </Box>
            </>
          ) : (
            <>
              {" "}
              <Breadcrumb
                id={data?.advertisement?.categoryId}
                booth={data?.booth}
                category={category}
              />
              <div className="md:grid md:grid-cols-2 gap-5">
                <div className="max-h-fit h-fit flex flex-col gap-6">
                  <Paper
                    elevation={0}
                    className="flex flex-col gap-6 max-h-fit h-fit"
                  >
                    <Gallery
                      data={data?.advertisement}
                      gallery={data?.gallery}
                    />
                    {/*    {isMd && <AdvertismentAd data={adInfo?.advertisement} />} */}
                  </Paper>
                  <div className="flex justify-center flex-wrap gap-5 items-center">
                    <Button
                      variant="contained"
                      onClick={() => setOpenDelete(true)}
                    >
                      تایید
                    </Button>
                    <Button
                      onClick={() => setOpenDelete2(true)}
                      variant="contained"
                      color="error"
                    >
                      رد
                    </Button>
                    <Button
                      onClick={() => setOpenDelete3(true)}
                      variant="outlined"
                      color="error"
                    >
                      حذف
                    </Button>
                  </div>
                </div>

                <div className="flex flex-col gap-6">
                  <Summery data={data?.advertisement} />
                  <AdInfo data={data?.advertisement} fields={data?.data} />
                  <Location data={data?.advertisement} />
                </div>
              </div>
            </>
          )}
        </Box>
        <Confirm
          message="آیا از رد این اگهی اطمینان دارید ؟ "
          close={() => setOpenDelete2(false)}
          submit={() => checkReview(2)}
          open={openDelete2}
        />
        <Confirm
          message="آيا از تایید این اکهی اطمینان دارید ؟‌"
          close={() => setOpenDelete(false)}
          submit={() => checkReview(1)}
          open={openDelete}
        />{" "}
        <Confirm
          message="آيا از حذف این اکهی اطمینان دارید ؟‌"
          close={() => setOpenDelete3(false)}
          submit={() => setDelete(1)}
          open={openDelete3}
        />{" "}
      </div>
    </>
  );
};

export default ReviewAds;
